import React from 'react';

// Default value is defined in SettingsContextProvider
export const SettingsContext = React.createContext({});
